import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { Roles } from 'src/app/interfaces/interfaces';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  emailUser: string;
  nombreUser: string;
  clasesUser: string;
  isAdmin: boolean;
  rolesUsuario: number[] = [0];
  seleccionRol:number;
  nombreRol:string;
  mostrarMenu:boolean=false;
  rolesCatalogo: { id_rol: number; nombre_rol: string; }[];
  roles: Roles[]=[];
  seleccionado=2;

  constructor(private authService: AuthService,private dataService: DataService) {
    //this.rolesCatalogoMe();
  }

  ngOnInit() {
    // Observar los cambios y obtener los estados del usuario
    this.authService.user.subscribe(email => this.emailUser = email);
    this.authService.userName.subscribe(nombre => this.nombreUser = nombre);
    this.authService.escuchaRolesUser().subscribe((res) => {this.roles = res;});
    //Rol seleccionado 
   this.authService.nombreRol$.subscribe(rolId => {
     if(rolId!=0){
      this.seleccionRol = rolId;
      this.mostrarMenu=true;
      this.rolesCatalogoMe();
     }
     else{
      this.seleccionRol = 0;
      this.mostrarMenu=false;
      this.roles=[];
     }
    },
    );

    if(this.seleccionRol)
    {
      this.mostrarMenu=true;
      this.rolesCatalogoMe();
      //this.nombreRoles(this.seleccionRol);
    }
    
    this.authService.isAdmin.subscribe(admin => this.isAdmin = admin);
    // Verificar si el usuario esta logeado pero no ha pasado por el proceso de autenticacion
    if (this.emailUser !== '') {
      this.authService.logOut();
    }
    // Administrar las calses del lugar donde se mostrará el usuario
    if (this.emailUser !== '') {
      this.clasesUser = 'col-9 p-1 pl-md-3 p-md-2 text-white';
    } else {
      this.clasesUser = 'col-9 p-2 p-md-4 text-white';
    }
  }  

  isInRole(rol: number): boolean {
    return this.authService.isInRole(rol);
  }

  logOut() {
    //this.nombreRolSubscrition.unsubscribe();
    this.mostrarMenu=false;
    this.nombreRol="";
    this.seleccionRol=0;
    this.roles=[];
    this.authService.logOut();
  }

  

   //Método para cargar los roles activos de BD
   rolesCatalogoMe()
   {
     this.dataService.obtenerTiposUsuariosv2().subscribe(
       data => {
         if(data['alert']==0 && data['data'].length > 0)
         {
          this.rolesCatalogo = data['data'];
          this.nombreRoles(this.seleccionRol);
         }
         
       },
       error => {
         //console.error(error);       
       }
     );
 
   }

   //Metodo para obtener el nombre del rol
   nombreRoles(rol) 
  { 
    if(this.rolesCatalogo.length > 0)
    {
      if (this.rolesCatalogo.indexOf(rol) === -1) 
      {
         for (var i in this.rolesCatalogo) 
         {
           if(this.rolesCatalogo[i].id_rol==rol)
           {
              this.nombreRol=this.rolesCatalogo[i]['nombre_rol'];
            }
         }
     } else if (this.rolesCatalogo.indexOf(rol) > -1) {}

    }
    
}

onChangeRol(idRol:number)
{
  this.authService.emiteRolSeleccionado(idRol);
  this.nombreRoles(idRol);
  
}

ngOnDestroy() {
  this.seleccionRol=0;
  this.roles=[];
  this.nombreRol="";
  this.mostrarMenu=false;
  this.authService.nombreRol$.unsubscribe();
  window.location.reload();
}

}//Cierre de clase
